import React, { FC } from "react";

import GlobalFilter from "./GlobalFilter";
import Toolbar from "@material-ui/core/Toolbar";

interface Props {
  preGlobalFilteredRows: any;
  setGlobalFilter: any;
  globalFilter: any;
  update: (() => void) | null;
  pending: boolean;
  text: string;
  inputFullWidth?: boolean;
}

const TableToolbar: FC<Props> = ({
  preGlobalFilteredRows,
  setGlobalFilter,
  globalFilter,
  update,
  pending,
  text,
  inputFullWidth,
}) => {
  return (
    <Toolbar style={{ position: "sticky", background: "white", left: 0 }}>
      <GlobalFilter
        preGlobalFilteredRows={preGlobalFilteredRows}
        globalFilter={globalFilter}
        setGlobalFilter={setGlobalFilter}
        update={update}
        pending={pending}
        text={text}
        inputFullWidth={inputFullWidth}
      />
    </Toolbar>
  );
};

export default TableToolbar;
